<template>
  <div>
    <div>
      <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/default_header.png');
              background-position: top !important;
            "
          ></div>
          <!-- <img src="/static/img/default_header.png" /> -->
          <div class="headline">
            <div
              class="text-subtitle-2 text-md-h5"
              v-if="selectedCategory != null"
            >
              {{ selectedCategory.designationMap[$locale] }}
              <img
                class="ml-2"
                src="../assets/img/arrow_right.svg"
                height="18px"
              /><img
                class="mr-2"
                src="../assets/img/arrow_right.svg"
                height="18px"
              />
              {{ $t("create_training") }}
            </div>
            <div class="text-subtitle-2 text-md-h5" v-else-if="editMode">
              {{ $t("edit_training") }}
            </div>
            <div class="text-subtitle-2 text-md-h5" v-else>
              {{ $t("create_training") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb
      v-if="!editMode"
      :traningCategoryName="categoryNameBreadCrumb"
      :traningCategoryLink="categoryNameBreadCrumbName"
    />
    <Breadcrumb
      v-else
      :traningCategoryName="categoryNameBreadCrumb"
      :traningCategoryLink="categoryNameBreadCrumbName"
      :trainingNameEdit="trainingNameEdit"
    />
    <div class="text-center">
      <v-dialog v-model="openDeleteDialog" width="500">
        <h4>{{ $t("confirm_delete_training") }}</h4>
        <v-card-actions class="align_center">
          <v-btn
            @click="openDeleteDialog = false"
            outlined
            depressed
            tile
            class="cancelBtn mr-2 mb-2"
          >
            {{ $t("cancel") }}</v-btn
          >
          <v-btn
            @click="deleteTraining()"
            v-show="$rights.includes('DELETE_TRAINING')"
            outlined
            depressed
            tile
            class="savebutton mb-2"
          >
            <img
              src="/static/img/popup-delete-icon.svg"
              class="popup-delete-icon"
            />
            {{ $t("delete") }}</v-btn
          >
        </v-card-actions>
      </v-dialog>

      <v-dialog v-model="openUnarchiveDialog" width="500">
        <div class="archive-icon-sec">
          <img src="/static/img/archive-icon.svg" />
        </div>
        <h4 class="archive-head-text">{{ $t("unarchive_training") }}</h4>
        <p class="archive-subhead">
          {{ $t("unarchive-popup") }}
        </p>
        <v-card-actions class="archive-buttons-wrap">
          <v-btn
            @click="openUnarchiveDialog = false"
            outlined
            depressed
            tile
            class="cancelBtn mr-2 mb-2"
          >
            {{ $t("cancel") }}</v-btn
          >
          <v-btn
            v-show="$rights.includes('UPDATE_TRAINING')"
            @click="archive('0')"
            outlined
            depressed
            tile
            class="savebutton mr-2 mb-2"
          >
            {{ $t("unarchiveButton") }}</v-btn
          >
        </v-card-actions>
      </v-dialog>
      <v-dialog
        class="Archive-Training-popup"
        v-model="openArchiveDialog"
        width="500"
      >
        <div class="archive-icon-sec">
          <img src="/static/img/archive-icon.svg" />
        </div>
        <h4 class="archive-head-text">{{ $t("archive_training") }}</h4>
        <p class="archive-subhead">
          {{ $t("archive-popup") }}
        </p>
        <v-card-actions class="archive-buttons-wrap">
          <v-btn
            @click="openArchiveDialog = false"
            outlined
            depressed
            tile
            class="cancelBtn mr-2 mb-2"
          >
            {{ $t("cancel") }}</v-btn
          >
          <v-btn
            v-show="$rights.includes('UPDATE_TRAINING')"
            @click="archive('1')"
            outlined
            depressed
            tile
            class="savebutton mr-2 mb-2"
          >
            <v-icon class="archive-mdi" color="#444">mdi-archive</v-icon>
            {{ $t("archiveButton") }}</v-btn
          >
        </v-card-actions>
      </v-dialog>
    </div>
    <div class="pt-8">
      <div class="row disablerow justify-content-between align-items-start">
        <!-- Tabs -->
        <v-tabs
          v-model="languageTab"
          align-with-title
          touchless
          scrollable
          show-arrows
          class="LanguageselectTabgroup pt-md-4 pt-lg-0 pl-md-8 pl-4"
        >
          <v-tabs-slider color="indigo"></v-tabs-slider>

          <v-tab
            v-for="(language, i) in languageTabsNew"
            :key="language + i"
            class="LanguageselectTab"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  style="display: flex; align-items: center"
                >
                  <img
                    style="width: 26px; height: 17px; vertical-align: unset"
                    :src="'/files/flags/' + language.flag"
                  />
                  &nbsp;&nbsp;
                  <span class="langauge-text-slider">
                    {{
                      language.shortForm === "KK"
                        ? "KZ"
                        : language.shortForm === "ZH" ||
                          language.shortForm === "CN"
                        ? "CN"
                        : $t(language.shortForm)
                    }}
                  </span>
                </div>
              </template>
              <span>{{ $t(language.language) }}</span>
            </v-tooltip>
          </v-tab>
        </v-tabs>
        <div class="col-md-12 col-xl-9 innercreatetraining">
          <v-tabs-items v-model="languageTab" touchless>
            <v-tab-item
              v-for="(language, i) in languageTabsNew"
              :key="language + i"
            >
              <div class="row disablerow justify-content-between">
                <!-- Put Content here -->
                <div class="col-md-4 px-0">
                  <div class="col-md-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('designation') + '*'"
                      v-model="training.designations[language.shortForm]"
                    ></v-text-field>
                  </div>
                  <div class="col-md-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      readonly
                      disabled
                      :label="$t('training_idnr')"
                      v-model="trainingId"
                    ></v-text-field>
                  </div>
                  <div
                    class="col-md-12 disablemrow row justify-content-between"
                  >
                    <div
                      class="col-md-6 pb-md-0 row disablerow justify-content-start min-number-participants"
                    >
                      <v-text-field
                        hide-details="auto"
                        class="col-md-11 datainput pb-1"
                        dense
                        outlined
                        :min="1"
                        type="number"
                        :rules="[positiveNumberRule]"
                        :label="$t('minParticipants') + '*'"
                        v-model="training.minParticipants"
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 row disablerow justify-content-end">
                      <v-text-field
                        hide-details="auto"
                        class="col-md-11 datainput pb-1"
                        dense
                        outlined
                        :min="1"
                        type="number"
                        :rules="[positiveNumberRule]"
                        :label="$t('maxParticipants') + '*'"
                        v-model="training.maxParticipants"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('price_eur')"
                      v-model="training.price"
                    ></v-text-field>
                  </div>
                </div>
                <div class="col-md-4 px-0">
                  <div class="col-md-12 pb-4">
                    <v-select
                      dense
                      outlined
                      class="datainput"
                      hide-details="auto"
                      :items="categories1"
                      item-text="text"
                      item-value="value"
                      :label="$t('category') + '*'"
                      v-model="training.category"
                    ></v-select>
                  </div>
                  <div class="col-md-12 pb-4">
                    <v-select
                      hide-details="auto"
                      dense
                      outlined
                      class="datainput"
                      :items="types"
                      :label="$t('training_type') + '*'"
                      item-text="text"
                      item-value="value"
                      v-model="training.type"
                    ></v-select>
                  </div>
                  <div class="col-md-12 pb-4">
                    <v-autocomplete
                      dense
                      outlined
                      multiple
                      hide-details="auto"
                      class="datainput"
                      :items="selectableLocations"
                      item-text="name"
                      item-value="id"
                      :label="$t('location') + '*'"
                      v-model="training.selectedLocations"
                    ></v-autocomplete>
                  </div>
                  <div class="col-md-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('duration_in_days')"
                      v-model="training.durationInDays"
                    ></v-text-field>
                  </div>
                </div>
                <div class="col-md-4 px-0">
                  <div class="col-md-12">
                    <Upload
                      v-model="training.documents"
                      multiple
                      allowOtherFileTypes
                    />
                    <div class="upload-limit-text">
                      {{ $t("max_size_1000mb") }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <v-checkbox
                      v-model="training.isPopular"
                      class="ml-3 populer-training-box"
                      :label="$t('popular')"
                      hide-details="auto"
                    ></v-checkbox>
                  </div>
                  <div class="col-md-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('sort_number')"
                      v-model="training.sortNumber"
                    ></v-text-field>
                  </div>
                </div>

                <div class="col-md-12 px-0">
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("goals") }}
                      </label>
                      <vue-editor
                        v-model="training.goals[language.shortForm]"
                        :editor-toolbar="customToolbar"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("targetgroup") }}
                      </label>
                      <vue-editor
                        v-model="training.targetGroups[language.shortForm]"
                        :editor-toolbar="customToolbar"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("content") }}
                      </label>
                      <vue-editor
                        v-model="training.descriptions[language.shortForm]"
                        :editor-toolbar="customToolbar"
                        @input="handleInput"
                      />
                    </div>
                    <div class="upload-limit-text">
                      {{ $t("characterCount") }}:
                      <span
                        :style="{
                          color:
                            characterCount > maxCharacterCount
                              ? 'red'
                              : 'inherit',
                        }"
                      >
                        {{ characterCount }}</span
                      >
                      /{{ maxCharacterCount }}
                      <div
                        v-if="characterCount > maxCharacterCount"
                        style="color: red"
                      >
                        {{ $t("characterExceeded") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("prerequesites") }}
                      </label>
                      <vue-editor
                        v-model="training.prerequesites[language.shortForm]"
                        :editor-toolbar="customToolbar"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <div class="text-right mb-4 col-md-12">
              <v-label> * {{ $t("mandatory_fields") }} </v-label>
            </div>
            <div class="col-md-12 lastBtnSubmit all-btn-wrap g-space-15">
              <v-btn
                v-if="!editMode"
                @click="saveTraining()"
                v-show="$rights.includes('CREATE_TRAINING')"
                outlined
                depressed
                tile
                :disabled="characterCount > maxCharacterCount"
                class="savebutton"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                v-else
                @click="saveTraining()"
                v-show="$rights.includes('UPDATE_TRAINING')"
                outlined
                depressed
                tile
                :disabled="characterCount > maxCharacterCount"
                class="savebutton"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="cancelBtn"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                v-show="editMode && $rights.includes('DELETE_TRAINING')"
                @click="openDeleteDialog = true"
                outlined
                depressed
                tile
                class="deletebutton cancelBtn"
                ><v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
              <v-btn
                v-if="training.trainingflag === '0'"
                v-show="editMode && $rights.includes('UPDATE_TRAINING')"
                @click="openArchiveDialog = true"
                outlined
                depressed
                tile
                class="savebutton"
                ><v-icon color="#444">mdi-archive</v-icon>
                {{ $t("archiveButton") }}</v-btn
              >
              <v-btn
                v-if="training.trainingflag === '1'"
                v-show="editMode && $rights.includes('UPDATE_TRAINING')"
                @click="openUnarchiveDialog = true"
                outlined
                depressed
                tile
                class="savebutton"
              >
                {{ $t("unarchiveButton") }}</v-btn
              >
              <div
                v-if="training.trainingflag === '1'"
                class="unarchive-info-text-wrap"
              >
                <h6>{{ $t("archivetext1") }}</h6>
                <p>{{ $t("archivetext2") }}<br />{{ $t("archivetext3") }}</p>
              </div>
            </div>
          </v-tabs-items>
        </div>
        <div class="col-xl-3 px-0 pl-8 pl-md-4 row pt-0 onlyContact">
          <div class="col-xl-12 right-side-block hide">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              v-show="editMode && $rights.includes('DELETE_TRAINING')"
              @click="openDeleteDialog = true"
              outlined
              depressed
              tile
              class="deletebutton mr-2 mb-2"
              ><v-icon color="#444">mdi-delete</v-icon>
              {{ $t("delete") }}</v-btn
            >
            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="backbutton mr-2 mb-2"
            >
              <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
            >
            <v-btn
              v-if="!editMode"
              @click="saveTraining()"
              v-show="$rights.includes('CREATE_TRAINING')"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
            <v-btn
              v-else
              @click="saveTraining()"
              v-show="$rights.includes('UPDATE_TRAINING')"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
          </div>

          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./custom/Card.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Card,
    Breadcrumb,
  },

  props: {
    categoryName: String,
    trainingId: Number,
  },

  data() {
    return {
      positiveNumberRule: (value) => {
        return value >= 0 || this.$t("Please_Enter_number");
      },
      characterCount: 0,
      maxCharacterCount: 1050,
      editMode: false,
      allCategories: [], // Full data of category list
      categories: [], // only data for select boxes
      languageTab: null,
      selectedCategory: null,
      openDeleteDialog: false,
      openArchiveDialog: false,
      openUnarchiveDialog: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],
      locations: [],

      selectableLearningTarget: [],

      categoryNameBreadCrumb1: "",
      categoryNameBreadCrumbName: "",
      trainingNameEdit1: "",
      training: {
        designations: {},
        goals: {},
        targetGroups: {},
        prerequesites: {},
        descriptions: {},
        type: null,
        qualificationNumber: null,
        category: null,
        minParticipants: null,
        maxParticipants: null,
        showUpcomingSchedules: true,
        selectedLocations: [],
        isPopular: false,
        documents: [],
        selectedLearning: [],
        selectedLearningTarget: null,
      },
    };
  },

  update() {},
  computed: {
    languageTabsNew() {
      return this.$root.languageTabsNew;
    },
    selectableLearning() {
      return [
        { id: "Beginner", name: this.$t("Beginner") },
        { id: "Intermediate", name: this.$t("Intermediate") },
        { id: "Advanced", name: this.$t("Advanced") },
      ];
    },
    types() {
      return [
        { value: "PRESENCE", text: this.$t("PRESENCE") },
        { value: "VIDEO", text: this.$t("VIDEO") },
        { value: "VIRTUAL", text: this.$t("VIRTUAL") },
        {
          value: "PRESENCE_AND_VIRTUAL",
          text: this.$t("PRESENCE_AND_VIRTUAL"),
        },
      ];
    },

    trainingLocationTypes() {
      return {
        CUSTOMER: { id: -1, name: this.$t("training_at_customer") },
        VIRTUAL: { id: -2, name: this.$t("virtual") },
        ACADEMY: { id: -3, name: this.$t("at_trainingacademy") },
      };
    },
    selectableLocations() {
      return [
        this.trainingLocationTypes.CUSTOMER,
        this.trainingLocationTypes.VIRTUAL,
        this.trainingLocationTypes.ACADEMY,
      ];
    },
    categories1() {
      const categories = Array.isArray(this.allCategories)
        ? this.allCategories
            .filter((category) => category.designationMap[this.$locale])
            .map((category) => ({
              value: category.id,
              text: category.designationMap[this.$locale],
            }))
            .sort((a, b) => {
              const textA = a.text ? a.text.trim().toLowerCase() : "";
              const textB = b.text ? b.text.trim().toLowerCase() : "";
              return textA.localeCompare(textB, this.$locale, {
                sensitivity: "base",
              });
            })
        : [];
      return categories;
    },
    categoryNameBreadCrumb() {
      return this.selectedCategory
        ? this.selectedCategory.designationMap[this.$locale]
        : "";
    },
    trainingNameEdit() {
      return this.training && this.training.designationsMap
        ? this.training.designationsMap[this.$locale.toUpperCase()]
        : "";
    },
  },
  mounted() {
    if (
      this.categoryName == null &&
      window.location.href.includes("create-training")
    ) {
      this.categoryName = window.location.href.substring(
        window.location.href.lastIndexOf("/") + 1
      );
      if (this.categoryName.includes("?")) {
        this.categoryName = this.categoryName.substring(
          0,
          this.categoryName.indexOf("?")
        );
      }
    }

    if (this.categoryName != null || this.editMode) {
      this.fetchSelectedCategory();
    }
    this.fetchCategories();

    this.selectableLocations = [];
    this.selectableLocations.push(this.trainingLocationTypes.CUSTOMER);
    this.selectableLocations.push(this.trainingLocationTypes.VIRTUAL);
    this.selectableLocations.push(this.trainingLocationTypes.ACADEMY);

    if (this.trainingId != null) {
      this.editMode = true;
      this.fetchEditingTraining();
    }
  },

  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    handleInput() {
      this.characterCount =
        this.training.descriptions[this.$locale.toUpperCase()].length;
    },
    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },

    fetchCategories() {
      var _this = this;
      this.$axios
        .get("api/category")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const category = response.data[i];
            if (category.designationMap[_this.$locale]) {
              _this.categories.push({
                value: category.id,
                text: category.designationMap[_this.$locale],
              });
            }
          }
          _this.allCategories = response.data;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchSelectedCategory() {
      var _this = this;
      this.$axios
        .get("/api/category/url", {
          params: {
            url: _this.categoryName,
          },
        })
        .then(function (response) {
          _this.training.category = {
            value: response.data.id,
            text: response.data.designationMap[_this.$locale],
          };
          _this.selectedCategory = response.data;
          _this.categoryNameBreadCrumbName = _this.selectedCategory.id;
        })
        .catch(this.onError);
    },

    fetchEditingTraining() {
      var _this = this;
      this.$axios
        .get("/api/training/" + this.trainingId)
        .then(function (response) {
          _this.training = response.data;

          _this.categoryName = _this.training.category.id;

          _this.categoryNameBreadCrumbName = _this.training.category.id;
          _this.categoryNameBreadCrumb =
            _this.training.category.designationMap[_this.$locale];

          _this.training.category = {
            value: _this.training.category.id,
            text: _this.training.category.designationMap[_this.$locale],
          };
          _this.trainingNameEdit =
            _this.training.designationsMap[_this.$locale];
          _this.training.designations = _this.training.designationsMap;
          _this.lowerCaseMapKeys(_this.training.designations);
          _this.training.descriptions = _this.training.descriptionsMap;
          _this.lowerCaseMapKeys(_this.training.descriptions);
          _this.training.goals = _this.training.goalsMap;
          _this.lowerCaseMapKeys(_this.training.goals);
          _this.training.targetGroups = _this.training.targetGroupsMap;
          _this.lowerCaseMapKeys(_this.training.targetGroups);
          _this.training.prerequesites = _this.training.prerequesitesMap;
          _this.lowerCaseMapKeys(_this.training.prerequesites);

          // Preselect Training Locations and Types
          _this.training.selectedLocations = [];

          for (let i = 0; i < _this.training.locationTypes.length; i++) {
            const locationType = _this.training.locationTypes[i];
            if (locationType == "CUSTOMER") {
              _this.training.selectedLocations.push(
                _this.trainingLocationTypes.CUSTOMER.id
              );
            }
            if (locationType == "VIRTUAL") {
              _this.training.selectedLocations.push(
                _this.trainingLocationTypes.VIRTUAL.id
              );
            }
            if (locationType == "ACADEMY") {
              _this.training.selectedLocations.push(
                _this.trainingLocationTypes.ACADEMY.id
              );
            }
          }

          for (let i = 0; i < _this.training.locations.length; i++) {
            const location = _this.training.locations[i];
            _this.training.selectedLocations.push(location.id);
          }
          _this.fetchSelectedCategory();
        })
        .catch(this.onError);
    },

    saveTraining() {
      var _this = this;
      var training = {};

      let updatedTraining = Object.assign({}, _this.training);
      training = Object.assign(training, updatedTraining);
      const languages = [
        "EN",
        "DE",
        "FR",
        "PL",
        "ES",
        "HU",
        "RU",
        "KK",
        "IT",
        "ZH",
      ];

      const allEmptyOrSpaces = languages.every((lang) =>
        this.$isStringEmptyOrNull(training.designations[lang])
      );

      if (allEmptyOrSpaces) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("designation") })
        );
        return;
      }

      if (training.type == null) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("training_type") })
        );
        return;
      }
      if (training.category == null) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("category") }));
        return;
      }

      if (
        training.minParticipants == null ||
        training.minParticipants == "" ||
        isNaN(training.minParticipants)
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("minParticipants") })
        );
        return;
      } else if (training.minParticipants <= 0) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("Please_Enter_number") })
        );
        return;
      }

      if (
        training.maxParticipants == null ||
        training.maxParticipants == "" ||
        isNaN(training.maxParticipants)
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("maxParticipants") })
        );
        return;
      } else if (training.maxParticipants <= 0) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("Please_Enter_number") })
        );
        return;
      }

      training.minParticipants = parseInt(training.minParticipants);
      training.maxParticipants = parseInt(training.maxParticipants);
      if (training.minParticipants > training.maxParticipants) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("maxParticipants") })
        );
        return;
      }
      if (
        training.selectedLocations == null ||
        training.selectedLocations.length == 0
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("location") })
        );
        return;
      }

      training.locationTypes = "";
      training.locations = "";

      for (let i = 0; i < training.selectedLocations.length; i++) {
        var selectedLocation = training.selectedLocations[i]; // id
        if (selectedLocation <= 0) {
          if (selectedLocation == this.trainingLocationTypes.CUSTOMER.id) {
            selectedLocation = "CUSTOMER";
          }
          if (selectedLocation == this.trainingLocationTypes.VIRTUAL.id) {
            selectedLocation = "VIRTUAL";
          }
          if (selectedLocation == this.trainingLocationTypes.ACADEMY.id) {
            selectedLocation = "ACADEMY";
          }
          training.locationTypes += ";" + selectedLocation;
        } else {
          training.locations += ";" + selectedLocation;
        }
      }
      if (training.locationTypes.startsWith(";")) {
        training.locationTypes = training.locationTypes.substring(1);
      }
      if (training.locations.startsWith(";")) {
        training.locations = training.locations.substring(1);
      }

      if (training.selectedLearning != null) {
        training.learningTypes = training.selectedLearning.join(";");
      }

      if (training.selectedLearningTarget != null) {
        training.learningTargetTypes =
          training.selectedLearningTarget.join(";");
      }

      training.categoryId =
        training.category.value == null
          ? training.category
          : training.category.value;

      if (training.sortNumber && /\D/.test(training.sortNumber)) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("sort_number") })
        );
        return;
      }

      this.$convertHtmlDescriptionText(training.goals);
      this.$convertHtmlDescriptionText(training.targetGroups);
      this.$convertHtmlDescriptionText(training.descriptions);
      this.$convertHtmlDescriptionText(training.prerequesites);

      if (this.editMode) {
        // Edit Training
        this.$axios
          .put("/api/training/" + this.trainingId, training)
          .then(function (response) {
            _this.$noty.success(
              _this.$t("training_edited", {
                name:
                  response.data.designationsMap[_this.$locale] == "undefined"
                    ? response.data.designationsMap["EN"]
                    : response.data.designationsMap[_this.$locale],
              })
            );
            _this.$router.push(
              "/category?categoryId=" + response.data.category.id
            );
          })
          .catch(this.onError);
      } else {
        // Create new Training
        this.$axios
          .post("/api/training", training)
          .then(function (response) {
            _this.$noty.success(
              _this.$t("training_saved", {
                name: response.data.designationsMap[_this.$locale],
              })
            );
            _this.$router.push(
              "/category?categoryId=" + response.data.category.id
            );
          })
          .catch(this.onError);
      }
    },

    deleteTraining() {
      if (this.trainingId == null) {
        console.error("You are not editing an existing training.");
        return;
      }

      var _this = this;

      this.$axios
        .delete("/api/training/" + this.trainingId)
        .then(function (response) {
          _this.$noty.success(
            _this.$t("training_deleted", {
              name: _this.training.designationsMap[_this.$locale],
            })
          );
          _this.$routerBack();
        })
        .catch(this.onError);
    },
    archive(trainingFlagCode) {
      var _this = this;
      var training = {};
      training = Object.assign(training, this.training);

      const updatedTraining = Object.assign({}, this.training, {
        trainingFlag: trainingFlagCode,
      });
      training = Object.assign(training, updatedTraining);

      if (training.type == null) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("training_type") })
        );
        return;
      }
      if (training.category == null) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("category") }));
        return;
      }
      if (
        training.minParticipants == null ||
        training.minParticipants == "" ||
        isNaN(training.minParticipants)
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("minParticipants") })
        );
        return;
      }
      if (
        training.maxParticipants == null ||
        training.maxParticipants == "" ||
        isNaN(training.maxParticipants)
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("maxParticipants") })
        );
        return;
      }

      training.minParticipants = parseInt(training.minParticipants);
      training.maxParticipants = parseInt(training.maxParticipants);
      if (Number(training.minParticipants) > Number(training.maxParticipants)) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("maxParticipants") })
        );
        return;
      }
      if (
        training.selectedLocations == null ||
        training.selectedLocations.length == 0
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("location") })
        );
        return;
      }

      training.locationTypes = "";
      training.locations = "";

      for (let i = 0; i < training.selectedLocations.length; i++) {
        var selectedLocation = training.selectedLocations[i]; // id
        if (selectedLocation <= 0) {
          if (selectedLocation == this.trainingLocationTypes.CUSTOMER.id) {
            selectedLocation = "CUSTOMER";
          }
          if (selectedLocation == this.trainingLocationTypes.VIRTUAL.id) {
            selectedLocation = "VIRTUAL";
          }
          if (selectedLocation == this.trainingLocationTypes.ACADEMY.id) {
            selectedLocation = "ACADEMY";
          }
          training.locationTypes += ";" + selectedLocation;
        } else {
          training.locations += ";" + selectedLocation;
        }
      }
      if (training.locationTypes.startsWith(";")) {
        training.locationTypes = training.locationTypes.substring(1);
      }
      if (training.locations.startsWith(";")) {
        training.locations = training.locations.substring(1);
      }

      if (training.selectedLearning != null) {
        training.learningTypes = training.selectedLearning.join(";");
      }

      if (training.selectedLearningTarget != null) {
        training.learningTargetTypes =
          training.selectedLearningTarget.join(";");
      }

      training.categoryId =
        training.category.value == null
          ? training.category
          : training.category.value;

      this.$convertHtmlDescriptionText(training.goals);
      this.$convertHtmlDescriptionText(training.targetGroups);
      this.$convertHtmlDescriptionText(training.descriptions);
      this.$convertHtmlDescriptionText(training.prerequesites);

      if (this.editMode) {
        // Edit Training
        this.$axios
          .put("/api/training/" + this.trainingId, training)
          .then(function (response) {
            _this.$router.push(
              "/category?categoryId=" + response.data.category.id
            );
          })
          .catch(this.onError);
      } else {
        // Create new Training
        this.$axios
          .post("/api/training", training)
          .then(function (response) {
            _this.$noty.success(
              _this.$t("training_saved", {
                name: response.data.designationsMap[_this.$locale],
              })
            );
            _this.$router.push(
              "/category?categoryId=" + response.data.category.id
            );
          })
          .catch(this.onError);
      }
    },

    onFinally() {
      showLoadingCircle(false);
    },
  },
};
</script>
